import { render, staticRenderFns } from "./EPHAD.vue?vue&type=template&id=460ca36e"
import script from "./EPHAD.vue?vue&type=script&lang=js"
export * from "./EPHAD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports